<template>
  <b-card>
    <b-row>
      <b-col>
        <b-row class="mb-2">
          <b-col cols="5">
            <div class="heading1-title">Link Button</div>
          </b-col>
          <b-col cols="7">
            <div class="float-right align-items-center">
              <b-icon-arrows-move></b-icon-arrows-move>
              <b-icon-files @click="copyComponent"></b-icon-files>
              <b-icon-trash-fill @click="removeComponent"></b-icon-trash-fill>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Button Text">
          <b-form-input size="sm" v-model="component.text"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Link">
          <b-form-input size="sm" v-model="component.link" placeholder="https://your-domain.com"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="4">
        <text-color-picker label="Background Color" :component-style="component.style"></text-color-picker>
      </b-col>
      <b-col cols="3">
        <b-form-group label="Radius">
          <b-input-group size="sm" append="px">
            <b-form-input type="number" v-model="component.style.border.radius"></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <text-style-editor :text="component.style.text"></text-style-editor>
    <b-row>
      <b-col>
        <b-button v-b-toggle.collapse-1 size="sm" variant="link">Advanced
          <b-icon-chevron-down></b-icon-chevron-down>
        </b-button>
      </b-col>
    </b-row>
    <b-collapse id="collapse-1" class="mt-2">
      <b-row>
        <b-col cols="4">
          <text-color-picker label="Border Color" :component-style="component.style.border"></text-color-picker>
        </b-col>
        <b-col cols="4">
          <b-form-group label="Border Weight">
            <b-input-group size="sm" append="px">
              <b-form-input type="number" v-model="component.style.border.weight"></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <margin-editor :element="component.style"></margin-editor>
        </b-col>
      </b-row>
    </b-collapse>
  </b-card>
</template>

<script>
import marginEditor from './marginEditor';
import textStyleEditor from './textStyleEditor';
import textColorPicker from './textColorPicker';

export default {
  name: 'inAppLinkButton',
  components: {
    textColorPicker,
    textStyleEditor,
    marginEditor,
  },
  props: {
    component: '',
    remove: '',
    copy: '',
  },
  methods: {
    removeComponent() {
      this.remove(this.component.id);
    },
    copyComponent() {
      this.copy(this.component);
    },
  },
};
</script>
